import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SUCCESS_FEE_TAX, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Renders the seller's success-fee tax line (exclusive mode) plus a note that
 * the tax is added on top of the success fee. Provider-only.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {boolean} props.isProvider - Whether the current viewer is the provider
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element|null}
 */
const LineItemSuccessFeeTaxMaybe = props => {
  const { lineItems, isProvider, marketplaceName, intl } = props;

  const taxLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SUCCESS_FEE_TAX && !item.reversal
  );

  if (!isProvider || !taxLineItem) {
    return null;
  }

  return (
    <>
      <div className={css.lineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage id="OrderBreakdown.successFeeTax" />
        </span>
        <span className={css.itemValue}>{formatMoney(intl, taxLineItem.lineTotal)}</span>
      </div>
      <span className={css.feeInfo}>
        <FormattedMessage id="OrderBreakdown.successFeeTaxNote" />
      </span>
    </>
  );
};

export default LineItemSuccessFeeTaxMaybe;
